/**
 * The "(REQUIRED)" suffix after a required field's label — one component so
 * every modal renders it identically. Sits inside the <label>, so it becomes
 * part of the field's accessible name ("Reason (REQUIRED)").
 */
export function RequiredMark() {
  return <span className="font-bold"> (REQUIRED)</span>;
}
